import React, { useEffect } from 'react';
import {
  CarInformationSelector,
  CurrentStepContentSelector,
  CurrentStepSelector,
  FitStatusSelector,
  HasLoadedFromCookieSelector,
  InitialDataSelector,
  ProductDetailsSelector,
  TranslationsSelector,
} from '../../Selectors/FitAssistantSelectors';
import { useAppDispatch, useAppSelector } from '../../Store/store.ts';
import { resetFitAssistant } from '../../Thunks/Reset.ts';
import { setFitStatus, setShowFitAssistant } from '../../Slices/FitAssistantSlice.ts';
import { IsProductPage } from '../../../FitAssistantShared/IsProductPage.js';
import { SetFitStatusForAllProducts } from '../../../FitAssistantShared/Functions.js';
import { CookieHelper } from '../../Helpers/CookieHelper.ts';
import { ProductPageHelper } from '../../Helpers/ProductPageHelper.ts';
import { trackFit, trackOK, trackView } from '../../Analytics/Adobe.ts';
import Buttons from '../Buttons/Buttons.tsx';
import FitAssistantStatus from '../../Enums/FitAssistantStatus.ts';
import PrimaryButton from '../Buttons/PrimaryButton.tsx';
import SecondaryButton from '../Buttons/SecondaryButton.tsx';
import { CloseType } from '../../Types/Tracking.ts';

const RackMountingSelector = () => {
  const dispatch = useAppDispatch();
  const carInformation = useAppSelector(CarInformationSelector);
  const currentStep = useAppSelector(CurrentStepSelector);
  const currentStepContent = useAppSelector(CurrentStepContentSelector);
  const fitStatus = useAppSelector(FitStatusSelector);
  const initialData = useAppSelector(InitialDataSelector);
  const productDetail = useAppSelector(ProductDetailsSelector);
  const translations = useAppSelector(TranslationsSelector);
  const hasLoadedFromCookie = useAppSelector(HasLoadedFromCookieSelector);

  useEffect(() => {
    trackView(
      initialData.FitAssistantVariation,
      currentStep,
      initialData.IsYearFirst,
      carInformation,
      hasLoadedFromCookie
    );
  }, []);

  const trackConfirmedClick = (closeType: CloseType, clickLink?: string) => {
    trackFit(
      initialData.FitAssistantVariation,
      currentStep,
      initialData.IsYearFirst,
      carInformation,
      closeType,
      clickLink
    );
  };

  const onClickPrimary = () => {
    dispatch(setFitStatus(FitAssistantStatus.RackMounting));
    if (IsProductPage) {
      ProductPageHelper.HandleRackMountingProductPageData(productDetail, initialData, dispatch);
    } else {
      SetFitStatusForAllProducts(FitAssistantStatus.Confirmed);
    }
    CookieHelper.SetCookies('', FitAssistantStatus.RackMounting);
    dispatch(setShowFitAssistant(false));

    trackOK(initialData.FitAssistantVariation, currentStep, initialData.IsYearFirst, carInformation);
    trackConfirmedClick('Close');
  };

  const onClickSecondary = () => {
    trackConfirmedClick('Reset');
    dispatch(resetFitAssistant(false));
  };

  return (
    <>
      <div>
        <div
          className="mb-6"
          dangerouslySetInnerHTML={{
            __html: currentStepContent?.Text ?? '',
          }}
        />
        {currentStepContent?.ImageUrl && (
          <div className="cms-image-wrapper d-flex justify-content-center w-100">
            <img src={currentStepContent?.ImageUrl} alt={currentStepContent?.ImageAlt} />
          </div>
        )}
      </div>
      <Buttons visible>
        <PrimaryButton visible text={translations.confirm} onClick={onClickPrimary} />
        <SecondaryButton
          visible={fitStatus === FitAssistantStatus.RackMounting}
          text={translations.reset}
          onClick={onClickSecondary}
        />
      </Buttons>
    </>
  );
};

export default RackMountingSelector;
